import {
  booleanDecoder,
  booleanEncoder,
  nullableBooleanEncoder,
  dateDecoder,
  dateEncoder,
  nullableDateDecoder,
  nullableDateEncoder,
  numberDecoder,
  numberEncoder,
  numbersDecoder,
  numbersEncoder,
  numericEnumsDecoder,
  numericEnumsEncoder,
  stringDecoder,
  stringEncoder,
  stringEnumDecoder,
  stringEnumEncoder,
  stringEnumsDecoder,
  stringEnumsEncoder,
  stringsDecoder,
  stringsEncoder,
  nullableBooleanDecoder,
  nullableNumberEncoder,
  nullableNumberDecoder,
} from '@/ui/routes/query';
import { queryState } from './queryState';

export const stringEnum = <T extends string>(
  key: string,
  values: T[],
  fallback: T,
  debounce = true,
) => queryState<T>(
  key,
  stringEnumEncoder,
  stringEnumDecoder(values, fallback),
  stringEnumEncoder(fallback),
  debounce,
);

export const numericEnums = <T extends number>(
  key: string,
  values: T[],
  fallback: T[],
  debounce = true,
) => queryState<T[]>(
  key,
  numericEnumsEncoder,
  numericEnumsDecoder(values),
  numericEnumsEncoder(fallback),
  debounce,
);

export const stringEnums = <T extends string>(
  key: string,
  values: T[],
  fallback: T[],
  debounce = true,
) => queryState<T[]>(
  key,
  stringEnumsEncoder,
  stringEnumsDecoder(values),
  stringEnumsEncoder(fallback),
  debounce,
);

export const boolean = (
  key: string,
  fallback: boolean,
) => queryState<boolean>(
  key,
  booleanEncoder,
  booleanDecoder,
  booleanEncoder(fallback),
);

export const nullableBoolean = (
  key: string,
  fallback: boolean | null,
) => queryState<boolean | null>(
  key,
  nullableBooleanEncoder,
  nullableBooleanDecoder,
  nullableBooleanEncoder(fallback),
);

export const number = (
  key: string,
  fallback: number,
) => queryState<number>(
  key,
  numberEncoder,
  numberDecoder,
  numberEncoder(fallback),
);

export const nullableNumber = (
  key: string,
  fallback: number | null,
) => queryState<number | null>(
  key,
  nullableNumberEncoder,
  nullableNumberDecoder,
  nullableNumberEncoder(fallback),
);

export const string = (
  key: string,
  fallback: string,
  debounce = true,
) => queryState<string>(
  key,
  stringEncoder,
  stringDecoder,
  stringEncoder(fallback),
  debounce,
);

export const date = (key: string, fallback: Date) => queryState<Date>(
  key,
  dateEncoder,
  dateDecoder,
  dateEncoder(fallback),
);

export const nullableDate = (key: string, fallback: Date | null) => queryState<Date | null>(
  key,
  nullableDateEncoder,
  nullableDateDecoder,
  nullableDateEncoder(fallback),
);

export const numbers = (key: string, fallback: number[]) => queryState<number[]>(
  key,
  numbersEncoder,
  numbersDecoder,
  numbersEncoder(fallback),
);

export const strings = (key: string, fallback: string[]) => queryState<string[]>(
  key,
  stringsEncoder,
  stringsDecoder,
  stringsEncoder(fallback),
);
